"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _tinymce = _interopRequireDefault(require("tinymce"));

var _react = _interopRequireWildcard(require("react"));

var _FormatSelect = _interopRequireDefault(require("rich-text-lib/components/formatting/FormatSelect"));

var _usageTracking = require("../../utils/usageTracking");

var _usageTracking2 = require("../../constants/usageTracking");

var TinyMceFormatSelect =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TinyMceFormatSelect, _Component);

  function TinyMceFormatSelect(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TinyMceFormatSelect);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TinyMceFormatSelect).call(this, props));

    _this.handleFormatChange = function (event) {
      var editor = _this.props.editor;
      var format = event.target.value;

      var applyFormat = function applyFormat() {
        editor.execCommand('mceToggleFormat', false, format);
      };

      editor.undoManager.transact(function () {
        if (_this.state.value === 'blockquote') {
          editor.formatter.remove('blockquote');
        }

        if (format === 'blockquote') {
          editor.execCommand('hsblockquote');
        } else if (_this.state.value === 'pre') {
          editor.execCommand('hscodeblock', false, {
            format: format,
            applyFormatDefault: applyFormat
          });
        } else {
          applyFormat();
        }

        if (format === 'pre' || format === 'blockquote') {
          editor.execCommand('hsInsertNewline', false, {
            target: editor.dom.getParent(editor.selection.getRng().startContainer, format)
          });
        }
      });
      (0, _usageTracking.trackInteraction)(editor, 'tinymceFormatting', _usageTracking2.CHANGE_BLOCK_FORMAT, {
        method: 'button',
        value: format
      });
    };

    _this.handleNodeChange = function (event) {
      var _this$props = _this.props,
          formats = _this$props.formats,
          editor = _this$props.editor;

      if (!event.element) {
        return;
      }

      var matchedFormat = formats.find(function (_ref) {
        var value = _ref.value;
        return editor.formatter.match(value, {}, event.element);
      });
      var isWithinBlockquote = event.parents ? event.parents.find(function (parent) {
        return parent.nodeName === 'BLOCKQUOTE';
      }) : null;

      var _ref2 = matchedFormat || {
        value: null
      },
          value = _ref2.value;

      if (isWithinBlockquote) {
        value = 'blockquote';
      }

      if (value !== _this.state.value) {
        _this.setState({
          value: value
        });
      }
    };

    _this.state = {
      value: null
    };
    _this.formats = props.formats;
    return _this;
  }

  (0, _createClass2.default)(TinyMceFormatSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.editor.on('NodeChange', this.handleNodeChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.editor.off('NodeChange', this.handleNodeChange);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_FormatSelect.default, {
        use: "on-dark",
        formats: this.formats,
        value: this.state.value,
        onChange: this.handleFormatChange,
        dropdownClassName: "mce-format-select"
      });
    }
  }]);
  return TinyMceFormatSelect;
}(_react.Component);

exports.default = TinyMceFormatSelect;
TinyMceFormatSelect.propTypes = {
  editor: _react.PropTypes.instanceOf(_tinymce.default.Editor).isRequired,
  formats: _react.PropTypes.array.isRequired
};
module.exports = exports.default;